import { render, staticRenderFns } from "./DeleteMainCategory.vue?vue&type=template&id=3f881d88&scoped=true"
import script from "./DeleteMainCategory.vue?vue&type=script&lang=js"
export * from "./DeleteMainCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f881d88",
  null
  
)

export default component.exports